// extracted by mini-css-extract-plugin
export default {"actions":"ZollDevicesTable_actions_YoLKp"};